<div
  class="card-form-group-container"
  [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      placeholder="Numero catalogo generale (NCTN)"
      formControlName="NCTN">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Codice regione (NCTR)"
      formControlName="NCTR">
  </mat-form-field>
</div>
